import React from 'react'
import { useTranslation } from 'react-i18next'
import { RoomChargeResultStatus } from '../../types'
import { RoomChargeActionButton, RoomChargeActionIcon } from '../index.styled'
import { ResultBadge, ResultBadgeIcon, ResultBlock, ResultText, ResultTitle } from './index.styled'

type Props = {
	status: RoomChargeResultStatus
	guestName?: string
	roomNumber?: string
	errorCode?: string | null
	errorMessage?: string | null
	onRetry: () => void
}

const DAY_LOCKED_CODE = 'day_locked'

const RoomChargeResultStep = React.memo(({
	status, guestName, roomNumber, errorCode, errorMessage, onRetry,
}: Props) => {
	const { t } = useTranslation()
	const isDayLocked = errorCode === DAY_LOCKED_CODE

	if (status === 'processing') {
		return (
			<ResultBlock>
				<ResultBadge>
					<RoomChargeActionIcon icon="loader" className="spinning" />
				</ResultBadge>
				<ResultTitle>{t('RoomCharge.result.processingTitle')}</ResultTitle>
				<ResultText>{[roomNumber, guestName].filter(Boolean).join(' · ')}</ResultText>
			</ResultBlock>
		)
	}

	return (
		<>
			<ResultBlock>
				<ResultBadge className="failed">
					<ResultBadgeIcon icon="alert-triangle" />
				</ResultBadge>
				<ResultTitle>{t(isDayLocked ? 'RoomCharge.result.dayLockedTitle' : 'RoomCharge.result.failedTitle')}</ResultTitle>
				<ResultText>
					{isDayLocked ? t('RoomCharge.result.dayLockedText') : errorMessage || t('RoomCharge.result.failedText')}
				</ResultText>
			</ResultBlock>
			<RoomChargeActionButton type="button" onClick={onRetry}>
				{t('RoomCharge.result.retry')}
			</RoomChargeActionButton>
		</>
	)
})

RoomChargeResultStep.displayName = 'RoomChargeResultStep'
export default RoomChargeResultStep
